import http from 'hub-http/clients/apiClient';
export const acceptAudio = (executionId, contentId) => {
  return http.post(`content/audio-generation/v1/executions/${executionId}/accept`, {
    data: {
      contentId
    }
  });
};
export const fetchTranscriptViaProxy = path => {
  return http.get(`filemanager/api/v3/files/proxy/${encodeURIComponent(path)}`, {
    query: {
      cachebuster: Date.now()
    }
  });
};